import '.ex{line-height:var(--line-height-body);}.ssr-plugin'
import '.c9{margin-top:0px;}.ssr-plugin'
import '.ey{margin-bottom:1.5rem;}.ssr-plugin'
import { styled, Style } from 'inlines'

interface OrderedListProps extends React.HTMLAttributes<HTMLOListElement> {
  style?: Style
}

export const OrderedList = ({ children, style, ...rest }: OrderedListProps) => {
  return (
    <styled.ol className="ex c9 ey"
      {...rest}
      style={{
        '& > li': { marginTop: 0, marginBottom: '1rem' },
        ...style,
      }}
    >
      {children}
    </styled.ol>
  )
}
